// Comment AI feature entry — owned by the comments feature.
import { MessagesSquare } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const comments: FeatureModule = {
  id: "comments",
  nav: [{ to: "/comments", label: "Comment replies", icon: MessagesSquare, group: "replies", order: 20 }],
  routes: [
    {
      path: "/comments",
      lazy: async () => {
        const { CommentsPage } = await import("./CommentsPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <CommentsPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default comments;
